import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { BaseComponent } from "../base.component";
import { DonorService } from "../services/donor.service";

@Component({
    selector: "personal-story",
    templateUrl: "./personal-story.component.html",
    styleUrls: ["./personal-story.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PersonalStoryComponent extends BaseComponent  {
    @Input() donorEditCommon: DonorService;
    @Input() validationError: string | null = null;
    readonly personalStoryMaxLength = 512;
    personalStory: string = "";

    constructor() {
        super();
    }

    protected _afterComponentInit(): void {}
    protected _afterComponentDestroy(): void {}
}
